/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { mobileOrderItemGroupModifierCreateSchema } from "./mobileOrderItemGroupModifierCreateSchema.ts";

export const mobileOrderItemGroupUnionModifierCreateSchema = z.object({
	group: z.uuid(),
	modifiers: z.array(mobileOrderItemGroupModifierCreateSchema),
});
